export default "__VITE_ASSET__OXzYIVpx__"